export default {
    key: 'mac',
    label: 'MAC',
    surname: [
        // Predators & Hunters
        'Apex',
        'Stalker',
        'Predator',
        'Hunter',
        'Reaper',
        'Raptor',
        'Viper',
        'Jackal',
        'Lynx',
        'Wolverine',
        'Warhound',
        'Hellhound',
        'Scorpion',
        'Mantis',
        'Barracuda',
        'Dire Wolf',
        'Komodo',
        'Mauler',
        'Dingo',
        'Harrier',
        'Mongoose',

        // Birds of Prey
        'Falcon',
        'Hawk',
        'Eagle',
        'Osprey',
        'Kestrel',
        'Condor',
        'Vulture',
        'Merlin',
        'Peregrine',
        'Shrike',
        'Kite',
        'Skua',

        // Mythological & Ancient
        'Titan',
        'Goliath',
        'Colossus',
        'Leviathan',
        'Behemoth',
        'Juggernaut',
        'Cyclops',
        'Nemesis',
        'Hydra',
        'Basilisk',
        'Chimera',
        'Cerberus',
        'Fenrir',
        'Mjolnir',
        'Valkyrie',
        'Ragnarok',
        'Kraken',
        'Minotaur',
        'Griffin',
        'Wyvern',
        'Gorgon',
        'Typhon',
        'Morrigan',
        'Jormungandr',
        'Charybdis',

        // Natural Forces
        'Tempest',
        'Cyclone',
        'Maelstrom',
        'Avalanche',
        'Thunderstrike',
        'Blizzard',
        'Firestorm',
        'Inferno',
        'Quake',
        'Tsunami',
        'Gale',
        'Eruption',
        'Shockwave',
        'Sandstorm',
        'Tremor',
        'Torrent',
        'Scorcher',
        'Mudslide',
        'Hailstorm',
        'Flashpoint',

        // Military & Tactical
        'Ironclad',
        'Bulwark',
        'Vanguard',
        'Rampart',
        'Citadel',
        'Sentinel',
        'Warden',
        'Paladin',
        'Crusader',
        'Marauder',
        'Ravager',
        'Decimator',
        'Annihilator',
        'Obliterator',
        'Devastator',
        'Vindicator',
        'Retaliator',
        'Liberator',
        'Enforcer',
        'Subjugator',
        'Dreadnought',
        'Centurion',
        'Gladiator',
        'Dragoon',
        'Grenadier',
        'Warlord',
        'Conquistador',
        'Legionnaire',
        'Hussar',
        'Conqueror',
        'Vanquisher',
        'Dominator',
        'Besieger',
        'Assailant',
        'Berserker',

        // Siege Weapons
        'Trebuchet',
        'Catapult',
        'Ballista',
        'Battering Ram',
        'Bombard',
        'Culverin',
        'Mortar',
        'Phalanx',
        'Onager',
        'Scorpio',

        // Space & Cosmic
        'Nova',
        'Pulsar',
        'Quasar',
        'Nebula',
        'Void',
        'Eclipse',
        'Solaris',
        'Helios',
        'Oblivion',
        'Singularity',
        'Eventide',
        'Darkstar',
        'Ironstar',
        'Zenith',
        'Corona',
        'Abyss',
        'Stardust',
        'Comet',
        'Perihelion',
        'Asteroid',
        'Supernova',
        'Neutron',

        // Materials & Elements
        'Ironsides',
        'Steelheart',
        'Titanfall',
        'Obsidian',
        'Adamant',
        'Tungsten',
        'Cobalt',
        'Magnesium',
        'Chromium',
        'Titanium',
        'Carbide',
        'Onyx',
        'Flint',
        'Basalt',
        'Osmium',
        'Iridium',
        'Vanadium',
        'Graphite',
        'Beryllium',

        // Sharp & Cutting
        'Razor',
        'Talon',
        'Fang',
        'Saber',
        'Scythe',
        'Cleaver',
        'Cutlass',
        'Javelin',
        'Halberd',
        'Lancer',
        'Dirk',
        'Stiletto',
        'Katana',
        'Claymore',
        'Scimitar',
        'Kukri',
        'Gladius',
        'Falchion',
        'Glaive',
        'Bardiche',

        // Speed & Motion
        'Blitz',
        'Surge',
        'Havoc',
        'Rampage',
        'Onslaught',
        'Interceptor',
        'Strider',
        'Galloper',
        'Bolt',
        'Blaze',
        'Afterburner',
        'Overdrive',
        'Zephyr',
        'Nitro',
        'Flashfire',
        'Quickstrike',
        'Skirmisher',

        // Shadows & Darkness
        'Shadow',
        'Specter',
        'Phantom',
        'Wraith',
        'Banshee',
        'Revenant',
        'Ghost',
        'Nightstalker',
        'Dusk',
        'Umbra',
        'Twilight',
        'Midnight',
        'Shade',
        'Penumbra',
        'Gloom',
        'Obscura',
        'Nocturn',
        'Darkling',
    ]
};
